import { type ContactAddress } from "@repo/api";
import { cs, HeadingL } from "@repo/ui";
import { useFormikContext } from "formik";
import { type FC } from "react";
import AddressTemplate from "../AddressBox/AddressTemplate";
import InformationList from "../InformationList";

const OverviewAddress: FC<ContactAddress> = ({
	contractNumber,
	title,
}) => {
	const { values } = useFormikContext();
	return (
		<>
			<HeadingL>{cs.global.changesOverview}</HeadingL>

			<InformationList
				information={[
					{
						title: cs.global.product,
						description: `${title} (${contractNumber})`,
					},
					{
						title: cs.global.address,
						description: <AddressTemplate address={values} />,
					},
				]}
			/>
		</>
	);
}

export default OverviewAddress;
